const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '1080P蓝光级画质，每一帧都清晰细腻。自适应码率技术确保各类网络环境下都能获得最佳观看体验。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '多线CDN全球加速，智能节点调度确保秒级加载。无需等待缓冲，点击即可流畅播放，追剧快人一步。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    desc: '同步各大卫视及网络平台最新热播内容。追剧日历一目了然，热播剧集当晚更新，绝不让你错过精彩。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '手机、电脑、平板无缝切换。观影记录云端同步，在家用大屏、出门用手机，随时随地继续追剧。',
    color: 'bg-primary-100 text-primary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-shield-check-line"></i>
            为什么选择我们
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-2">四大核心优势，打造极致追剧体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/60 cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${feat.color} mb-4 transition-transform group-hover:scale-110`}>
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}